import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';
import { AppRoute } from 'routing/AppRoute.enum';

export const useOwnerArchivedView = () => {
  const isOwnersArchivedView = useIsExactPath(AppRoute.ownersArchived);

  return { isOwnersArchivedView: !!isOwnersArchivedView };
};
